import { ListFormat } from 'typescript';
import { Url } from '../Constants/Url';
import AxiosApiService from './AxiosService';

export const Service = {
    getUserById, updateUser, getAllApprovedUsers, getAllUsers, sendInvite, registerUser, getAllRoles, getSubmittedUsers, authentication, getAllTTBTypeAndFacility, updateUserProfile,
    resetUserPassword, getSubmittedUsersCount, uploadAndSave , removeUserProfile, getLoginHistory, fetchOpenRequestCount, fetchOpenRequestsCountForWarehouse, fetchRecentRequestCount, fetchUnreadMessages,
    uploadDocs,fetchCompaniesList,fetchCompaniesOpenRequestCountByCompanyId, fetchCompanyUserData, fetchCompanyById, addUser, addCompany, getCityAndState, getEmailById, getActiveUsersCount, getAllRejectedUsers, getRejectedUsersCount
    ,fetchRequestData, changePassword, uploadProfileImage, getProfileImage,sendResetPasswordLink, removeProfileImage, logout, deleteCompanyById, getUserRoles, fetchAllPermissions, saveAllPermissions, getRoleById, updateRoleDescription, 
    saveSupportRequest, getAllSupportRequests, getOpenSupportRequestCount, getCloseSupportRequestCount, getAllComments, updateSupportRequestStatus, downloadFile, fetchCompaniesWithPagination, getAllServiceType, getFieldByServiceType, 
    fetchUsersList, saveCustomerSupportRequest, getAllActiveAndInactiveCompanies, updateCustomerSupportRequestValue, getAllDeletedUsers, getDeleteUsersCount, hardDeleteUsers, getCompanyUsersData, fetchAllActiveCompanies, fetchAllActiveCompaniesCount,
    fetchAllCompaniesCount, fetchAllSuspendedCompanies, fetchAllSuspendedCompaniesCount, suspendCompanyById, activeCompanyId, getCompanyDetailsById, checkEmailExistOrNot, fetchAllActiveOwners, fetchAllDeletedOwners, fetchActiveOwnersCount, 
    fetchDeletedOwnerCount, saveBarrelOwner, getBarrelOwnerDetails, deleteOwner, fetchOwnerList, signUpUser, fetchAllRequestsForWarehouse, markMyInterest, checkMyInterest, getWantedToBuyNotificationToggleValue, saveWantedToBuyNotificationToggleValue,
    getWantedToBuyNotificationToggleValueForUser, saveWantedToBuyNotificationToggleValueForUser, getRecentLoginActivityData, fetchCustomerServiceRequestBarrelId, createImpersonationSwitchKey, fetchCustomerServiceRequestsLotLevelBarrel, getImpersonationToken,
    checkCompanyEligibility, removeCompanyFromActiveList, exportCompanies, downloadCompanyReport, getAllCarrierList
}

async function getUserById(userId : any) {
    return await AxiosApiService.get<Object>(Url.GET_USER_BY_USER_ID + userId);
}

async function updateUser(user: any) {
    return await AxiosApiService.put<Object>(Url.UPDATE_USER, user);
}

async function getAllApprovedUsers(companyId:any,page:any,size:any, filter: any, sortField: any , sortDirection: any, signal: AbortSignal) {
    return await AxiosApiService.postWithSearchParams<any>(Url.GET_ALL_USERS, 
        { 
            companyId: companyId,
            page:page,
            size:size,
            sortField: sortField, 
            sortDirection: sortDirection
        }, filter, { signal });
}

async function getAllDeletedUsers(companyId:any,page:any,size:any, filter: any, sortField: any, sortDirection: any, signal: AbortSignal) {
    return await AxiosApiService.postWithSearchParams<any>(Url.GET_ALL_DELETED_USERS, 
        { 
            companyId: companyId,
            page:page,
            size:size,
            sortField: sortField,
            sortDirection: sortDirection
        }, filter, { signal });
}

async function getAllUsers() {
    return await AxiosApiService.get<Object>(Url.GET_ALL_USERS);
}

async function sendInvite(emailIds: any,companyId: any, flag: any) {
    let path = Url.SEND_INVITE + "/" + flag + "/" + companyId;
    return await AxiosApiService.post<ListFormat>(path, emailIds);
}

async function authentication(credential: any) {
    return await AxiosApiService.post<any>(Url.LOGIN, credential);
}

async function logout() {
    return await AxiosApiService.get<any>(Url.LOGOUT);

}
async function registerUser(user: any) {
    return await AxiosApiService.post<Object>(Url.USER_REGISTRATION, user);
}

async function getAllRoles() {
    return await AxiosApiService.get<Object>(Url.GET_ALL_ROLES);

}

async function getUserRoles(includeSuperAdmin:boolean) {
    return await AxiosApiService.getWithParams<any>(Url.GET_USER_ROLES, {params: {
        includeSuperAdmin:includeSuperAdmin
    }});
}

async function getRoleById(id:any) {
    return await AxiosApiService.get<any>(Url.GET_ROLE_NAME_BY_ID + "/" + id);
}

async function getSubmittedUsers(companyId:any,page:any, size:any, filter: any, sortField: any, sortDirection: any, signal: AbortSignal) {
    return await AxiosApiService.postWithSearchParams<any>(Url.GET_SUBMITTED_USERS, 
        {
            companyId: companyId,
            page:page,
            size:size,
            sortField: sortField,
            sortDirection: sortDirection,
        }, filter, { signal });

}

async function updateUserProfile(user: any) {
    return await AxiosApiService.put<Object>(Url.UPDATE_STATUS_IN_BULK, user)
}

async function removeUserProfile(list:any,status : boolean) {
    let path = Url.BULK_REMOVE_PROFILES + "/" + status;
    return await AxiosApiService.put<Object>(path, list)
}

async function hardDeleteUsers(list:any) {
    return await AxiosApiService.put<Object>(Url.HARD_DELETE_USERS, list);
}

async function resetUserPassword(user: any) {
    return await AxiosApiService.post<Object>(Url.RESET_PASSWORD, user)
}


//    async function getAllInventory() {
//        let path = Url.GET_ALL_INVENTORY;
//        axiosInstance.defaults.headers.Accept = 'text/event-stream'
//        return await get(path, {})
//    }

//    async function getProductById(productId: any) {
//        let path = Url.GET_PRODUCT_BY_ID + productId;
//        //axiosInstance.defaults.headers.Accept= 'text/event-stream'
//        return await get(path, {})
//    }

async function uploadAndSave(fileUpload: any) {
    return await AxiosApiService.post<any>(Url.UPLOAD_CSV, fileUpload)
}

async function uploadDocs(fileUpload: any) {
    return await AxiosApiService.post<any>(Url.UPLOAD_DOC, fileUpload)
}

async function getAllTTBTypeAndFacility() {
    return await AxiosApiService.get<any>(Url.GET_ALL_TYPE_AND_FACILITY);
}

async function getSubmittedUsersCount(companyId:any) {
    return await AxiosApiService.getWithParams<any>(Url.GET_SUBMITTED_USER_COUNT, {params: {
        companyId: companyId
    }});
}

async function getLoginHistory(page:any, size:any){
    return await AxiosApiService.getWithParams<any>(Url.GET_LOGIN_HISTORY, {
        params: {
            page: page,
            size: size
        }
    });
}

async function fetchOpenRequestCount() {
    return await AxiosApiService.get<any>(Url.GET_OPEN_REQUEST_COUNT);
}

async function fetchOpenRequestsCountForWarehouse() {
    return await AxiosApiService.get<any>(Url.GET_WAREHOUSE_OPEN_REQUEST_COUNT);
}

async function fetchAllRequestsForWarehouse(statusList: any, excludeStatus: any, assignedTo: string, page:any, size:any, filter: any, sortField: any, sortDirection: any, signal: AbortSignal) {
    return await AxiosApiService.postWithSearchParams<any>(Url.GET_ALL_WAREHOUSE_REQUEST, 
        {
            statusList: statusList,
            excludeStatus: excludeStatus,
            assignedTo: assignedTo,
            page: page,
            size: size,
            sortField: sortField, 
            sortDirection: sortDirection
        }, filter, { signal });
}

async function fetchRecentRequestCount(companyId: string, page:any, size:any, filter: any, sortField: any, sortDirection: any, dashboardPrefrence: string, signal: AbortSignal) {
    return await AxiosApiService.postWithSearchParams<any>(Url.GET_RECENT_REQUEST_COUNT, 
        {
            companyId: companyId,
            page: page,
            size: size,
            sortField: sortField, 
            sortDirection: sortDirection,
            dashboardPrefrence: dashboardPrefrence,
        }, filter, { signal });
}

async function fetchRequestData(params: { id:string }) {
    console.log("id" + params);
    return await AxiosApiService.getWithParams<Object>(Url.GET_REQUEST_DATA, {
        params: {
            companyId: params
        }
    });
}

async function fetchUnreadMessages(params: { id:string },dashboardPrefrence: string ) {
    return await AxiosApiService.getWithParams<Object>(Url.FETCH_UNREAD_MESSAGES, {
        params: {
            companyId: params.id,
            dashboardPrefrence: dashboardPrefrence
        }
    });
}

async function fetchCompaniesList(){
    return await AxiosApiService.get<any>(Url.FETCH_COMPANIES_LIST);
}

async function fetchCompaniesWithPagination(page:any, size:any, filter: any, sortField: any, sortDirection: any, signal: AbortSignal){
    return await AxiosApiService.postWithSearchParams<Object>(Url.FETCH_ALL_COMPANIES_WITH_PAGINATION, 
        {
            page: page,
            size: size,
            sortField: sortField,
            sortDirection: sortDirection,
        }, filter, { signal });
}


async function fetchAllActiveCompanies(page:any, size:any, filter: any, sortField: any, sortDirection: any, signal: AbortSignal){
    return await AxiosApiService.postWithSearchParams<Object>(Url.FETCH_ALL_ACTIVE_COMPANIES, 
        {
            page: page,
            size: size,
            sortField: sortField,
            sortDirection: sortDirection,
        }, filter, { signal });
}

async function exportCompanies(filter: any, sortField: any, sortDirection: any, signal: AbortSignal) {
    return await AxiosApiService.postBlobWithSearchParams<Object>(Url.EXPORT_COMPANIES ,
            {
                sortField: sortField,
                sortDirection: sortDirection,
            }, filter, { signal }
    );
}

async function downloadCompanyReport(companyId: any,userId: any, fileName: any, notificationId: any,) {
    return await AxiosApiService.getWithParams<Object>(Url.DOWNLOAD_COMPANIES_REPORT ,
        {params: {
            companyId: companyId,
            userId: userId,
            fileName: fileName,
            notificationId: notificationId
        }
    }   
    );
}

async function fetchAllSuspendedCompanies(page:any, size:any, filter: any, sortField: any, sortDirection: any, signal: AbortSignal){
    return await AxiosApiService.postWithSearchParams<Object>(Url.FETCH_ALL_SUSPENDED_COMPANIES, 
        {
            page: page,
            size: size,
            sortField: sortField,
            sortDirection: sortDirection,
        }, filter, { signal });
}

async function fetchAllCompaniesCount() {
    return await AxiosApiService.get<any>(Url.FETCH_ALL_COMPANIES_COUNT);
}

async function fetchAllActiveCompaniesCount() {
    return await AxiosApiService.get<any>(Url.FETCH_ALL_ACTIVE_COMPANIES_COUNT);
}

async function fetchAllSuspendedCompaniesCount() {
    return await AxiosApiService.get<any>(Url.FETCH_ALL_SUSPENDED_COMPANIES_COUNT);
}

async function fetchCompaniesOpenRequestCountByCompanyId(companyId:any,dashboardPrefrence: string ) {
    return await AxiosApiService.getWithParams<any>(Url.FETCH_COMPANIES_OPEN_REQUEST_COUNT + '/' + companyId, {
        params: {
            dashboardPrefrence: dashboardPrefrence
        }
    });
}

async function fetchCompanyUserData(companyId:any) {
    return await AxiosApiService.get<any>(Url.FETCH_COMPANIES_USER_DATA + '/' + companyId);
}

async function fetchCompanyById(companyId:any) {
    return await AxiosApiService.get<any>(Url.FETCH_COMPANIES_BY_ID + '/' + companyId);
}

async function getEmailById(id:any) {
    return await AxiosApiService.get<any>(Url.GET_EMAIL_BY_ID + '/' + id);
}

async function addUser(data:any) {
    return await AxiosApiService.post<any>(Url.ADD_USER, data);
}

async function addCompany(data:any) {
    return await AxiosApiService.post<any>(Url.ADD_COMPANY,data);
}

async function getCityAndState(zipcode:any, countryCode:any) {
    return await AxiosApiService.getWithParams<any>(Url.GET_CITY_AND_STATE, {
        params: {
            zipCode: zipcode,
            countryCode: countryCode
        }
    });
}

async function getAllRejectedUsers(companyId:any,page:any,size:any, filter: any, sortField: any, sortDirection: any, signal: AbortSignal) {
    return await AxiosApiService.postWithSearchParams<any>(Url.GET_ALL_REJECTED_USERS,
        {
            companyId: companyId,
            page:page,
            size:size,
            sortField: sortField, 
            sortDirection: sortDirection
        },filter, { signal });
}

async function getRejectedUsersCount(companyId:any) {
    return await AxiosApiService.getWithParams<any>(Url.GET_REJECTED_USER_COUNT, {params: {
        companyId: companyId
    }});
}

async function getActiveUsersCount(companyId:any) {
    return await AxiosApiService.getWithParams<any>(Url.GET_ACTIVE_USER_COUNT, {params: {
        companyId: companyId
    }});
}

async function getDeleteUsersCount(companyId:any) {
    return await AxiosApiService.getWithParams<any>(Url.GET_DELETE_USER_COUNT, {params: {
        companyId: companyId
    }});
}

async function changePassword(passwordDetails: any) {
    return await AxiosApiService.put<Object>(Url.CHANGE_PASSWORD, passwordDetails);
}

async function uploadProfileImage(fileUpload: any) {
    return await AxiosApiService.post<any>(Url.UPLOAD_PROFILE_IMAGE, fileUpload)
}

async function getProfileImage(downloadDoc: any) {
    return await AxiosApiService.postBlob<Object>(Url.GET_PROFILE_IMAGE, downloadDoc);
}

async function sendResetPasswordLink(email:any) {
    return await AxiosApiService.get<any>(Url.SEND_RESET_PASSWORD_LINK + "/" + email);
}

async function removeProfileImage(fileUpload: any) {
    return await AxiosApiService.post<any>(Url.REMOVE_PROFILE_IMAGE, fileUpload)
}

async function deleteCompanyById(companyIds: any) {
    return await AxiosApiService.post<any>(Url.DELETE_COMPANIES_BY_ID , companyIds);
}

async function suspendCompanyById(companyIds: any) {
    return await AxiosApiService.post<any>(Url.SUSPEND_COMPANIES_BY_ID, companyIds);
}

async function activeCompanyId(companyIds: any) {
    return await AxiosApiService.post<any>(Url.ACTIVE_COMPANIES_BY_ID, companyIds);
}

async function fetchAllPermissions(roleId: any) {
    return await AxiosApiService.get<any>(Url.GET_ALL_PERMISSIONS + "/" + roleId);
}

async function updateRoleDescription(roleId:any, description:any) {
    return await AxiosApiService.getWithParams<any>(Url.UPDATE_ROLE_DESCRIPTION + "/" + roleId, {
        params:{
            description : description
        }
    })
}

async function saveAllPermissions(permissions:any, roleId:any) {
    return await AxiosApiService.post<any>(Url.SAVE_ROLES_AND_PERMISSIONS + "/" + roleId + "/save", permissions);
}

async function saveSupportRequest(formData:any) {

    return await AxiosApiService.post<any>(Url.SAVE_SUPPORT_REQUEST, formData);
}

async function getAllSupportRequests(companyId:any, supportStatus:any,page: any, size: any) {
    return await AxiosApiService.getWithParams<any>(Url.GET_SUPPORT_REQUEST, {
        params:{
            companyId: companyId,
            supportStatus: supportStatus,
            page: page,
            size: size
        }
    })
}

async function getAllComments(id:any) {
    return await AxiosApiService.get<any>(Url.GET_ALL_COMMENTS + "/" + id);
}

async function getOpenSupportRequestCount (id:any) {
    return await AxiosApiService.getWithParams<any>(Url.OPEN_SUPPORT_REQUEST_COUNT, {
        params:{
            companyId: id
        }
    })
}

async function getCloseSupportRequestCount (id:any) {
    return await AxiosApiService.getWithParams<any>(Url.CLOSE_SUPPORT_REQUEST_COUNT, {
        params:{
            companyId: id
        }
    })
}

async function updateSupportRequestStatus (id:any, status:any) {
    return await AxiosApiService.getWithParams<any>(Url.UPDATE_SUPPORT_REQUEST_STATUS + "/" + id, {
        params:{
            status: status
        }
    })
}

async function downloadFile (requestData:any) {
    return await AxiosApiService.postBlob<any>(Url.DOWNLOAD_SUPPORT_REQUEST_FILE, requestData)
}

async function getAllServiceType () {
    return await AxiosApiService.get<any>(Url.GET_ALL_SERVICE_TYPE);
}

async function getFieldByServiceType (serviceTypeId:any) {
    return await AxiosApiService.get<any>(Url.GET_FIELD_BY_SERVICE_TYPE + "/" + serviceTypeId);
}

async function saveCustomerSupportRequest (requestData:any) {
    return await AxiosApiService.post<any>(Url.SAVE_CUSTOMER_SUPPORT_REQUEST, requestData);
}

async function fetchUsersList (companyId:any) {
    return await AxiosApiService.get<any>(Url.GET_USER_LIST_BY_COMPANY_ID + "/" + companyId)
}

async function fetchOwnerList (companyId:any) {
    return await AxiosApiService.get<any>(Url.GET_OWNER_LIST_BY_COMPANY_ID + "/" + companyId);
}

async function getAllActiveAndInactiveCompanies(){
    return await AxiosApiService.get<any>(Url.GET_ALL_ACTIVE_AND_INACTIVE_COMPANIES);
}

async function getCompanyDetailsById (id:any) {
    return await AxiosApiService.get<any>(Url.GET_COMPANY_DETAILS_BY_ID + '/' + id);
}

async function updateCustomerSupportRequestValue (requestData:any) {
    return await AxiosApiService.post<any>(Url.UPDATE_CUSTOMER_SUPPORT_REQUEST_VALUE, requestData);
}

async function getCompanyUsersData() {
    return await AxiosApiService.getBlob<Object>(Url.FETCH_COMPANNY_USER_DATA);
}

async function checkEmailExistOrNot(email: any){
    return await AxiosApiService.get<any>(Url.CHECK_EMAIL_EXIST_OR_NOT+ "/" + email);
}

async function fetchAllActiveOwners (companyId:any,page:any,size:any, filter: any, sortField: any, sortDirection: any, signal: AbortSignal) {
    return await AxiosApiService.postWithSearchParams<any>(Url.FETCH_ACTIVE_OWNERS,
        {
            companyId: companyId,
            page:page,
            size:size,
            sortField: sortField, 
            sortDirection: sortDirection
        },filter, { signal });
}

async function fetchAllDeletedOwners (companyId:any,page:any,size:any, filter: any, sortField: any, sortDirection: any, signal: AbortSignal) {
    return await AxiosApiService.postWithSearchParams<any>(Url.FETCH_DELETED_OWNERS,
        {
            companyId: companyId,
            page:page,
            size:size,
            sortField: sortField, 
            sortDirection: sortDirection
        },filter, { signal });
}

async function fetchActiveOwnersCount (companyId:any) {
    return await AxiosApiService.getWithParams<any>(Url.FETCH_ACTIVE_OWNERS_COUNT, {
        params:{
            companyId:companyId
        }
    });
}

async function fetchDeletedOwnerCount (companyId:any) {
    return await AxiosApiService.getWithParams<any>(Url.FETCH_DELETED_OWNERS_COUNT, {
        params:{
            companyId:companyId
        }
    });
}

async function saveBarrelOwner (data:any) {
    return await AxiosApiService.post<any>(Url.SAVE_BARREL_OWNER, data);
}

async function getBarrelOwnerDetails (id:any) {
    return await AxiosApiService.get<any>(Url.FETCH_BARREL_OWNER_DETAILS + '/' + id);
}

async function deleteOwner(list:any) {
    return await AxiosApiService.post<Object>(Url.DELETE_BULK_OWNER, list);
}

async function signUpUser(userDetails:any) {
    return await AxiosApiService.post<any>(Url.SIGNUP, userDetails);
}

async function markMyInterest (markMyInterest:any) {
    return await AxiosApiService.post<any>(Url.MARK_MY_INTEREST, markMyInterest);
}

async function checkMyInterest(wantedToBuyId, userId) {
  return await AxiosApiService.getWithParams(Url.CHECK_MY_INTEREST, {
      params: {
        wantedToBuyId: wantedToBuyId,
        userId: userId
      }
    });
}

async function getWantedToBuyNotificationToggleValue() {
  return await AxiosApiService.get<any>(Url.GET_WANTED_TO_BUY_NOTIFICATION_VALUE);
}

async function saveWantedToBuyNotificationToggleValue(value: boolean) {
  return await AxiosApiService.get<any>(Url.SAVE_WANTED_TO_BUY_NOTIFICATION_VALUE + '/' + value);
}

async function getWantedToBuyNotificationToggleValueForUser(userId : any) {
  return await AxiosApiService.get<any>(Url.GET_WANTED_TO_BUY_NOTIFICATION_VALUE_FOR_USER + '/' + userId);
}

async function saveWantedToBuyNotificationToggleValueForUser(userId: string, value: boolean) {
  return await AxiosApiService.get<any>(
    Url.SAVE_WANTED_TO_BUY_NOTIFICATION_VALUE_FOR_USER + '/' + userId + '/' + value
  );
}

async function getRecentLoginActivityData(page:any, size:any, userId: any){
    return await AxiosApiService.getWithParams<any>(Url.GET_RECENT_LOGIN_ACTIVITY_DATA, {
        params: {
            page: page,
            size: size,
            userId: userId
        }
    });
}

async function fetchCustomerServiceRequestBarrelId(barrelId: any) {
  return await AxiosApiService.get<boolean>(Url.GET_CUSTOMER_SERVICE_REQUEST_BARREL_BY_ID + barrelId);
}

async function createImpersonationSwitchKey(userId: any) {
    return await AxiosApiService.post<any>(Url.LOGIN_USER_BY_USER_ID_AND_IMPERSONATE + userId, {});
}

async function getImpersonationToken(switchKey: any) {
    return AxiosApiService.postImpersonateUser<any>(Url.IMPERSONATE_TOKEN, {}, {headers: {"X-IMPERSONATE": switchKey}});
}

async function fetchCustomerServiceRequestsLotLevelBarrel(companyId: any, lotNo: any) {
  return await AxiosApiService.get<boolean>(Url.GET_CUSTOMER_SERVICE_REQUEST_LOT_LEVEL_BARREL + companyId + '/' + lotNo);
}

async function checkCompanyEligibility (companyId:any) {
    return await AxiosApiService.get<any>(Url.CHECK_COMPANY_ELIGIBILITY + '/' + companyId);
}

async function removeCompanyFromActiveList(companyId: any) {
    return await AxiosApiService.post<any>(Url.REMOVE_COMPANY_FROM_ACTIVELIST + companyId, {});
}

async function getAllCarrierList() {
    return await AxiosApiService.get<any>(Url.GET_ALL_CARRIER_LIST);
}
